import React from "react";
import { Route } from "react-router-dom";

import Home from "../pages/ibc-consultants";
import About from "../pages/about-us.js";
import Careers from "../pages/careers.js";
import Services from "../pages/services.js";
import StrategyDecisionMaking from "../pages/strategy-decision-making.js";
import OperationalExcellence from "../pages/operational-excellence.js";
import OrgTransformationChangeManagement from "../pages/org-transformation-and-change-management.js";
import DigitalTransformation from "../pages/digital-transformation.js";
import ContactUs from "../pages/contact-us.js";
import PrivacyPolicy from "../pages/privacy-policy.js";
import TermsAndConditions from "../pages/terms-and-conditions.js";

import Resources from "../pages/resources/resources.js";
import ResourcesDetails from "../pages/resources/resources-details.js";

const FrontendRoute = [

  /* =====================================================
   * Core Static Pages (Canonical URLs only)
   * ===================================================== */

  <Route key="home" path="/" element={<Home pageName="Home" />} />,

  <Route key="about" path="/about-us/" element={<About pageName="About Us" />} />,
  <Route key="careers" path="/careers/" element={<Careers pageName="Careers" />} />,
  <Route key="services" path="/services/" element={<Services pageName="Services" />} />,

  <Route
    key="strategy"
    path="/services/strategy-and-decision-making/"
    element={<StrategyDecisionMaking pageName="Strategy & Decision Making" />}
  />,
  <Route
    key="operations"
    path="/services/operational-excellence/"
    element={<OperationalExcellence pageName="Operational Excellence" />}
  />,
  <Route
    key="org-change"
    path="/services/org-transformation-and-change-management/"
    element={<OrgTransformationChangeManagement pageName="Org. Transformation & Change Management" />}
  />,
  <Route
    key="digital"
    path="/services/digital-transformation/"
    element={<DigitalTransformation pageName="Digital Transformation" />}
  />,

  <Route key="contact" path="/contact-us/" element={<ContactUs pageName="Contact Us" />} />,
  <Route key="privacy" path="/privacy-policy/" element={<PrivacyPolicy pageName="Privacy Policy" />} />,
  <Route key="terms" path="/terms-and-conditions/" element={<TermsAndConditions pageName="Terms and Conditions" />} />,


  /* =====================================================
   * Resources Hub (SEO Proposal Compliant)
   * ===================================================== */

  // Hub (all types)
  <Route
    key="resources"
    path="/resources/"
    element={<Resources pageName="Resources" />}
  />,

  // Type listing
  <Route
    key="resources-type"
    path="/resources/:type/"
    element={<Resources pageName="Newsletters" />}
  />,

//   <Route
//     key="resources-newsletters"
//     path="/resources/newsletters/"
//     element={<Insights pageName="Newsletters" />}
//   />,

  // Detail pages
  <Route
    key="resources-detail"
    path="/resources/:type/:slug/"
    element={<ResourcesDetails pageName="Resource Details" />}
  />,


  /* =====================================================
   * Fallback (keep LAST)
   * ===================================================== */

  <Route key="fallback" path="*" element={<Home pageName="Home" />} />,
];

export default FrontendRoute;
